import { v4 as uuidv4 } from 'uuid';

const getUuid = () => {
  const newId = uuidv4();

  return newId;
};

export default getUuid;
